import React from "react";
import styles from "../DeviceConfigForm.module.css";
import { ELECTRODE_SITES } from "../../../../utils/deviceConfiguration";

interface ElectrodeGridProps {
  /** Visual state per site; sites not listed render as unused. */
  stateOf: (site: string) => "unused" | "active" | "anode" | "cathode";
  onSiteClick: (site: string) => void;
  /** Site whose fan-out panel is currently open, so it can be highlighted. */
  openSite?: string | null;
  disabledSite?: (site: string) => boolean;
}

function ElectrodeGrid({ stateOf, onSiteClick, openSite, disabledSite }: ElectrodeGridProps) {
  return (
    <div className={styles.electrodeGrid}>
      {ELECTRODE_SITES.map((site) => {
        const state = stateOf(site);
        const disabled = disabledSite?.(site) ?? false;
        return (
          <button
            key={site}
            type="button"
            disabled={disabled}
            aria-pressed={state !== "unused"}
            className={[
              styles.electrodeChip,
              styles[`electrode_${state}`],
              openSite === site ? styles.electrodeChip_open : "",
              disabled ? styles.electrodeChip_disabled : "",
            ]
              .filter(Boolean)
              .join(" ")}
            onClick={() => onSiteClick(site)}
          >
            {site}
          </button>
        );
      })}
    </div>
  );
}

export default ElectrodeGrid;
